// src/utils/hrConstants.js
// ============================================================
// Centralized HR Module Constants
// Single source of truth for all Role and Department values
// used across the HR module, recruitment, onboarding, learning,
// performance, offboarding, and all HR sub-pages.
// ============================================================

/**
 * Standardized EMS Roles (Production Values)
 * Use these everywhere a role dropdown appears.
 */
export const EMS_ROLES = [
  "Employee",
  "Team Lead",
  "HR",
  "Admin",
];

/**
 * Standardized EMS Departments (Production Values)
 * Use these everywhere a department dropdown appears.
 */
export const EMS_DEPARTMENTS = [
  "Compliance",
  "Development",
  "Engineering",
  "Finance",
  "HR",
  "Operations",
  "QA",
];

/**
 * Fallback lists to use when Firestore has no data yet.
 * Mirrors the above for consistency.
 */
export const DEFAULT_DEPARTMENTS = EMS_DEPARTMENTS;
export const DEFAULT_ROLES = EMS_ROLES;

/**
 * Helper: returns <option> elements for roles.
 * Pass to a <select> using {ROLE_OPTIONS}.
 */
export function ROLE_OPTIONS({ includeAll = false, allLabel = "All Roles" } = {}) {
  const all = includeAll ? [<option key="all" value="all">{allLabel}</option>] : [];
  return [
    ...all,
    ...EMS_ROLES.map((r) => (
      <option key={r} value={r}>
        {r}
      </option>
    )),
  ];
}

/**
 * Helper: returns <option> elements for departments.
 * Pass to a <select> using {DEPT_OPTIONS()}.
 */
export function DEPT_OPTIONS({ includeAll = false, allLabel = "All Departments" } = {}) {
  const all = includeAll ? [<option key="all" value="all">{allLabel}</option>] : [];
  return [
    ...all,
    ...EMS_DEPARTMENTS.map((d) => (
      <option key={d} value={d}>
        {d}
      </option>
    )),
  ];
}
